import * as React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

const PaginationContext = React.createContext()

const Pagination = ({ pages, url, currentPage, children }) => {
  if (pages < 2) {
    return null
  }

  return (
    <nav aria-label="pagination" className="pagination">
      <PaginationContext.Provider value={{ url, currentPage }}>
        {children}
      </PaginationContext.Provider>
    </nav>
  )
}

function PaginationList({ children }) {
  return <ul className="list-reset pagination-list">{children}</ul>
}

function PaginationItem({ children }) {
  return <li className="pagination-item">{children}</li>
}

const PaginationLink = ({ as: Component = 'a', page, className, ...props }) => {
  const { url, currentPage } = React.useContext(PaginationContext)
  const active = page === currentPage
  return (
    <Component
      aria-label={`Page ${page}`}
      href={url(page)}
      className={classnames(className, { active })}
      {...props}
    >
      {page}
    </Component>
  )
}

Pagination.propTypes = {
  pages: PropTypes.number.isRequired,
  url: PropTypes.func.isRequired,
  currentPage: PropTypes.number.isRequired,
}

PaginationLink.propTypes = {
  page: PropTypes.number.isRequired,
  as: PropTypes.elementType,
}

export { Pagination, PaginationList, PaginationItem, PaginationLink }
